module.exports = __webpack_public_path__ + "static/media/sheriff.4c1f55f1.png";